import React from 'react';
import PropTypes from 'prop-types';

export default function IconInfoBlue({ className, style, size = 24 }) {
  return (
    <svg
      className={className}
      fill="none"
      height={size}
      style={{ flexShrink: 0, ...style }}
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" fill="#0084D1" r="10" />
      <path d="M12 11V16" stroke="white" strokeLinecap="round" strokeWidth="2" />
      <circle cx="12" cy="8" fill="white" r="1.25" />
    </svg>
  );
}

IconInfoBlue.propTypes = {
  className: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  style: PropTypes.object,
};
